// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r7_mp","type":"styles_type__3F7Zg","choices":"styles_choices__2Yj6v"};